import * as ScrollMagic from '@modules/scrollmagic';
import resolveConfig from '@modules/tailwindcss/resolveConfig';
import tailwindConfig from '@/tailwind.config.js';
import {
  ScrollMagicPluginIndicator,
  ScrollMagicPluginGsap,
} from '@modules/scrollmagic-plugins';
import { TimelineMax, TweenMax, Linear } from '@modules/gsap';
import { debounce } from '@modules/lodash';
import { isEditMode } from '@js/utils';

ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

const win = window;

export default class TextImageSticky {
  constructor(rootNode) {
    if (isEditMode()) {
      return;
    }

    this.controller = new ScrollMagic.Controller();

    this.$refs = {
      rootNode,
      image: rootNode.querySelector('.image'),
      imageMask: rootNode.querySelector('.image .mask'),
      textContainer: rootNode.querySelector('.text-container'),
      header: document.querySelector('.Header'),
    };

    this.setupScrollMagic();

    window.addEventListener('resize', debounce(this.resize.bind(this), 1000));
  }

  resize() {
    this.setupScrollMagic();
  }

  setupScrollMagic() {
    this.controller.destroy();

    this.controller = new ScrollMagic.Controller();
    const contentHeight = window.innerHeight - this.$refs.header.offsetHeight;

    new ScrollMagic.Scene({
      triggerElement: this.$refs.rootNode,
      duration: contentHeight * 0.95,
    })
      .setTween(
        new TimelineMax().add([
          TweenMax.fromTo(
            this.$refs.image,
            1,
            { y: this.transformY('from') },
            { y: this.transformY('to'), ease: Linear.easeNone },
          ),
        ]),
      )
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: this.$refs.rootNode,
      duration: contentHeight * 0.8 * 0.375,
    })
      .setTween(
        new TimelineMax().add([
          TweenMax.fromTo(
            this.$refs.imageMask,
            1,
            { height: '100%' },
            { height: '0%', ease: Linear.easeNone },
          ),
        ]),
      )
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: this.$refs.rootNode,
      duration: contentHeight * 0.8,
    })
      .setTween(
        new TimelineMax().add([
          TweenMax.fromTo(
            this.$refs.textContainer,
            1,
            { y: this.transformTextContainerY('from') },
            { y: this.transformTextContainerY('to'), ease: Linear.easeNone },
          ),
        ]),
      )
      .addTo(this.controller);
  }

  transformY(method) {
    const fullConfig = resolveConfig(tailwindConfig);
    const breakpoints = fullConfig.theme.screens;

    if (win.innerWidth <= parseFloat(breakpoints.lg)) {
      return '0%';
    }

    if (win.innerWidth <= parseFloat(breakpoints.xl)) {
      if (method === 'from') return '10vh';
      if (method === 'to') return '-15vh';
    }

    if (method === 'from') return '5vh';
    if (method === 'to') return '-20vh';
  }

  transformTextContainerY(method) {
    const fullConfig = resolveConfig(tailwindConfig);
    const breakpoints = fullConfig.theme.screens;

    if (win.innerWidth <= parseFloat(breakpoints.lg)) {
      return '0%';
    }

    if (win.innerWidth <= parseFloat(breakpoints.xl)) {
      if (method === 'from') return '-2vh';
      if (method === 'to') return '1vh';
    }

    if (method === 'from') return '-2vh';
    if (method === 'to') return '3vh';
  }
}
